/**
 * this service will be used for performing string to number conversions and common mathematical operations
 * @returns {NumberService}
 * @constructor
 */
let NumberService = function NumberService() {
  let sv = this;

  /**
   * removes all non digits from a string number and converts it to a decimal ('$45,000.14' => 45000.14)
   * @param str
   * @returns {number}
   */
  sv.parseDecimal = (str) => {
    let numbersOnly = str.replace(/[^0-9.]/g, '');
    return numbersOnly.length > 0 ? parseFloat(numbersOnly) : 0.0;
  };

  return sv;

};

export default NumberService;



// WEBPACK FOOTER //
// ./client/app/services/NumberService.js